<template>
<div class="home_container">
  <Carousel class="app-con"
  v-model="value2"
  autoplay
  loop
  >  
    <CarouselItem>
      <div class="demo-carousel">
        <div class="bn1">
        </div>
      </div>
    </CarouselItem>
    <CarouselItem>
      <div class="demo-carousel">
        <div class="bn2">
        </div>
      </div>
    </CarouselItem>
    <!-- <CarouselItem>
      <div class="demo-carousel">
        <div class="bn3">
        </div>
      </div>
    </CarouselItem>
    <CarouselItem>
      <div class="demo-carousel">
        <div class="bn4">
        </div>
      </div>
    </CarouselItem> -->
  </Carousel>
  <!-- <div class="home_ct">
    <div class="home_ct_title">核心技术</div>
    <div class="home_ct_png"></div>
    <div class="home_ct_content">
      <div class="home_ct_content_introduction">具有自主知识产权的细微特征提取方法和低资源深度学习非协作时间序列建模理论和技术，识别率与普适性兼顾，相同的数据，实现更好的模型</div>
      <div class="home_ct_content_container">
          <div class="home_ct_content_container_up">
              <div class="home_ct_content_container_box1"><div class="home_ct_content_container_words1"><div class="words1">对语音和音频信号处理物理机制深度认识</div></div><div class="circle1"></div></div>
              <div class="home_ct_content_container_box1"><div class="circle2"></div><div class="home_ct_content_container_words2"><div class="words2">融合物理机制的底层细微特征提取方法</div></div></div>
          </div>
          <div class="home_ct_content_container_middle">
              <div class="home_ct_content_container_box1"><div class="home_ct_content_container_words3">几十年的积累</div><div class="circle3"></div></div>
              <div class="home_ct_content_container_box1"><div class="circle2"></div><div class="home_ct_content_container_words4">融合物理机制的神经网络结构</div></div>
          </div>
          <div class="home_ct_content_container_down"> 
              <div class="home_ct_content_container_box1"><div class="home_ct_content_container_words1"><div class="words5">对语音和音频信号处理的理论深度理解和技术创新</div></div><div class="circle1"></div></div>
              <div class="home_ct_content_container_box1"><div class="circle2"></div><div class="home_ct_content_container_words2"><div class="words6">结合底层细微特征提取的深度神经网络建模方法和决策分析</div></div></div>
          </div>
      </div>
    </div>
  </div> -->

  <div class="home_business_area">
    <div class="title home_business_title"></div>
    <div class="home_business_content">
      <div class="home_business_left">
        <p class="home_business_left_title">{{selectSpan == 1?'工业互联网':'智能语音与音频处理'}}</p>
        <p style="height:120px">{{selectSpan == 1?'以细微特征检测，低资源、非协作建模为切入点，赋能工业设备健康与安全监测，并提供预测性维护方案':'基于清华大学语音与音频技术实验室三十余年的深厚积累，具备全栈语音技术，已广泛应用于呼叫中心智能化、运营商防诈骗反骚扰、金融防欺诈、音频安防等各类场景'}}</p>
        <span :style="{background:selectSpan == 1?'#5C1E7E':'#E5E5EA'}" @click="selectSpan = 1"></span><span :style="{background:selectSpan == 2?'#5C1E7E':'#E5E5EA'}" @click="selectSpan = 2"></span>
      </div>
      <div class="home_business_right">
        <img :src="'/static/home_business'+selectSpan+'.png'" alt="">
      </div>
    </div>
  </div>
  <!-- <div class="home_product_program">
    <div class="home_pp_title">产品方案</div>
    <div class="home_pp_content">
      <div class="home_pp_content_left" @click="moveleft()"></div>
      <div class="home_pp_content_middle">
        <div id="middle_inner" class="home_pp_content_middle_inner">
          <div class="middle_inner-box">
            <div class="middle_inner_png1"></div>
            <div class="ppwc">  
              <div class="ppw">工业设备健康与安全监护</div>
              <Button class="b_w" type="primary" ghost @click="route_industrial()">查看详情</Button>
            </div>
          </div>
          <div class="middle_inner-box">
            <div class="middle_inner_png2"></div>
            <div class="ppwc">
              <div class="ppw">超大规模高性能声纹库系统</div>
              <Button class="b_w" type="primary" ghost @click="route_voicepage1()">查看详情</Button>
            </div>
          </div>
          <div class="middle_inner-box">
            <div class="middle_inner_png3"></div>
            <div class="ppwc">
              <div class="ppw">高性能云平台</div>
              <Button class="b_w" type="primary" ghost @click="route_voicepage2()">查看详情</Button>
            </div>
          </div>
          <div class="middle_inner-box">
            <div class="middle_inner_png4"></div>
            <div class="ppwc">
              <div class="ppw">人机耦合平台</div>
              <Button class="b_w" type="primary" ghost @click="route_voicepage3()">查看详情</Button>
            </div>
          </div>
          <div class="middle_inner-box">
            <div class="middle_inner_png5"></div>
            <div class="ppwc">  
              <div class="ppw">智能语音处理系统</div>
              <Button class="b_w" type="primary" ghost @click="route_voicepage4()">查看详情</Button>
            </div>
          </div>
        </div>
      </div>
      <div class="home_pp_content_right" @click="moveright()"></div>
    </div>
  </div> -->


  <div class="home_news_center">
    <div class="title home_news_title"></div>
    <div class="home_nc_content">
      <div class="home_nc_content_box" @click="route_200519">
        <div class="box_container">
          <div :class="{'home_nc_news_png1_scale':scale1,'home_nc_news_png1':!scale1}" @mouseenter="png1_scale()" @mouseleave="png1_scale()"></div>
        </div>
        <div class="home_nc_news_words">
          <div class="home_nc_news_time">
            <div class="home_nc_news_time_date">07-09</div>
            <div class="home_nc_news_time_year">2021</div>
          </div>
          <div class="home_nc_news_title">
            <div class="home_nc_news_headline">华控智加荣获决赛三等奖</div>
            <div class="home_nc_news_introduction">2021年7月9日，由太原市人民政府、清华大学、中关村发展集团主办的中俄青年创新创业与创意大…</div>
          </div>
        </div>
      </div>
      
      <div class="home_nc_content_box" @click="route_200416">
        <div class="box_container">
          <div :class="{'home_nc_news_png2_scale':scale2,'home_nc_news_png2':!scale2}" @mouseenter="png2_scale()" @mouseleave="png2_scale()"></div>
        </div>
        <div class="home_nc_news_words">
          <div class="home_nc_news_time">
            <div class="home_nc_news_time_date">06-25</div>
            <div class="home_nc_news_time_year">2021</div>
          </div>
          <div class="home_nc_news_title">
            <div class="home_nc_news_headline">第一届国际化创新创业大赛圆满落幕</div>
            <div class="home_nc_news_introduction">北京时间6月25日，由成都高新区管委会、成都-亚马逊云科技联合创新中心主办，成都高新科技…</div>
          </div>
        </div>
      </div>
      <div class="home_nc_content_box" @click="route_200401">
        <span @click="more" class="more">更多>></span>
        <div class="box_container">
          <div :class="{'home_nc_news_png3_scale':scale3,'home_nc_news_png3':!scale3}" @mouseenter="png3_scale()" @mouseleave="png3_scale()"></div>
        </div>
        <div class="home_nc_news_words">
          <div class="home_nc_news_time">
            <div class="home_nc_news_time_date">01-29</div>
            <div class="home_nc_news_time_year">2021</div>
          </div>
          <div class="home_nc_news_title">
            <div class="home_nc_news_headline">清华电子院通过公安部重点攻关验收</div>
            <div class="home_nc_news_introduction">2021年1月29日，公安部物证鉴定中心在北京组织召开首批公安部刑事技术“双十计划”重点…</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="resolve">
    <div class="title resolve-png"></div>
    <p class="resolve-content">通过自主研发的同步多传感器信号采集智能边缘计算终端，实时采集设备核心部件的声音、振动、温度等信号，利用深度学习技术对数据进行建模分析，构建故障预测模型，同时在线获取设备实时运行工况数据构建知识图谱模型，对设备运行状态进行推理和决策分析，从而实现设备故障超早期诊断、健康预测性维护和智能化运行。</p>
    <div class="resolve-img"></div>
  </div>

  <!-- <div class="home_cooperation">
    <div class="home_cooperation_title"></div>
    <div class="home_cooperation_content">
      <div v-for="(item,index) in data" :key="index" class="home_cooperation_content_box">
        <img :src="'/static/cooperation'+index+'.png'" @mouseover="item.flag = true" @mouseleave="item.flag = false" :class="item.flag?'img_scale':'img_no_scale'" alt="">
      </div>
    </div>
  </div> -->




</div>
</template>

<script>
export default {
    data () {
      return {
        value1: 0,
        value2: 0,
        left : 0,
        scale1: false,
        scale2: false,
        scale3: false,
        data:[
          {flag:false},
          {flag:false},
          {flag:false},
          {flag:false},
          {flag:false},
          {flag:false},
          {flag:false},
          {flag:false},
          {flag:false},
          {flag:false}
        ],
        selectSpan:1
      }
    },
    methods: {
      moveleft(){
        var middle_inner = document.getElementById('middle_inner');
        if(this.left<0){
          this.left = this.left+305;
          middle_inner.style.marginLeft = this.left +'px'
        }
      },
      moveright(){
        var middle_inner = document.getElementById('middle_inner');
        if(this.left>-305){
          this.left = this.left-305;
          middle_inner.style.marginLeft = this.left +'px'
        }
      },
      route_introduction(){
        this.$router.push(
          {
            path: '/us/introduction'
          }
        );
        document.documentElement.scrollTop = '570';
      },
      more(event){
        event.stopPropagation()
        this.$router.push({
          path:'/us/news/page1'
        })
        document.documentElement.scrollTop = '0';
      },
      png1_scale(){
        this.scale1=!this.scale1;
      },
      png2_scale(){
        this.scale2=!this.scale2;
      },
      png3_scale(){
        this.scale3=!this.scale3;
      },
      png_scale1(){
        this.scale4=!this.scale4;
      },
      route_industrial(){
        this.$router.push(
          {
            path:'/product/industrial'
          }
        );
        document.documentElement.scrollTop = '0';
      },
      route_voicepage1(){
        this.$router.push(
          {
            path:'/product/voice/page1'
          }
        );
        document.documentElement.scrollTop = '0';
      },
      route_voicepage2(){
        this.$router.push(
          {
            path:'/product/voice/page2'
          }
        );
        document.documentElement.scrollTop = '0';
      },
      route_voicepage3(){
        this.$router.push(
          {
            path:'/product/voice/page3'
          }
        );
        document.documentElement.scrollTop = '0';
      },
      route_voicepage4(){
        this.$router.push(
          {
            path:'/product/voice/page4'
          }
        );
        document.documentElement.scrollTop = '0';
      },
      route_200519(){
        this.$router.push(
          {
            path:'/us/news20200519'
          }
        );
        document.documentElement.scrollTop = '0';
      },
      route_200416(){
        this.$router.push(
          {
            path:'/us/news20200416'
          }
        );
        document.documentElement.scrollTop = '0';
      },
      route_200401(){
        this.$router.push(
          {
            path:'/us/news20200401'
          }
        );
        document.documentElement.scrollTop = '0';
      },
    },
  }
</script>

<style scoped>


    .home_container{
      width: 100%;
      overflow: hidden;
      margin-top: 70px;
    }
    .ivu_carousel{
      overflow: hidden;
    }
    .app-con{
      width: 100%;
      height: 840px;
    }
    


    .bn1{
      width: auto;
      height: 840px;
      background:url('~@/../static/BN_1.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      overflow: hidden;
    }
    .bn2{
      width: auto;
      height: 840px;
      background:url('~@/../static/BN_2.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      overflow: hidden;
    }
    .bn3{
      width: auto;
      height: 840px;
      background:url('~@/../static/BN_3.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      overflow: hidden;
    }
    .bn4{
      width: auto;
      height: 840px;
      background:url('~@/../static/BN_4.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      overflow: hidden;
    }



    .title{
      margin: 80px auto 40px auto;
      width: 428px;
      height: 70px;
    }
    .home_cooperation_title{
      margin: 80px auto 40px auto;
      width: 600px;
      height: 72px;
      background: url('~@/../static/home_cooperation_title.png');
    }
    .home_business_title{
      background: url('~@/../static/home_business_title.png');
    }
    .home_news_title{
      background: url('~@/../static/home_news_title.png');
    }
    .home_ct_title{
      width:120px;
      height:42px;
      font-size:30px;
      font-family:Noto Sans SC;
      font-weight:500;
      color:rgba(51,51,51,1);
      line-height:42px;
      margin: 80px auto auto auto;
    }
    .home_ct_content{
      background:url('~@/../static/2.0-ct-advantage.png');
      background-size: 548px 548px;
      background-position: center;
      background-repeat: no-repeat;
      height: 600px;
    }
    .home_ct_content_introduction{
        width:640px;
        font-size:16px;
        font-family:Noto Sans SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:24px;
        margin: 8px auto auto auto;
        text-align: center;
    }
    .home_ct_content_container{
        overflow: hidden;
    }
    .home_ct_content_container_up{
        width: 1200px;
        display: flex;
        justify-content: space-between;
        margin: 77px auto auto auto;
    }
    .home_ct_content_container_middle{
        width: 1080px;
        display: flex;
        justify-content: space-between;
        margin: 52px auto auto auto;
    }
    .home_ct_content_container_down{
        width: 1140px;
        display: flex;
        justify-content: space-between;
        margin: 46px auto auto auto;
    }
    .home_ct_content_container_box1{
        width: 392px;
        height: 84px;
        display: flex;
    }
    .home_ct_content_container_words1{
      width:354px;
      height:77px;
      background: linear-gradient(180deg, #F9FBFF 0%, #E7EEFF 100%);
      box-shadow:0px 4px 9px 0px rgba(115,176,255,0.41);
      border-radius:4px;
      align-items: center;
    }
    .words1{
      width:190px;
      height:50px;
      font-size:18px;
      font-family:Noto Sans SC;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:25px;
      text-align: center;
      margin: 14px auto auto auto;
    }
    .words2{
      width:200px;
      height:50px;
      font-size:18px;
      font-family:Noto Sans SC;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:25px;
      text-align: center;
      margin: 14px auto auto auto;
    }
    
    .words5{
      width:198px;
      height:50px;
      font-size:18px;
      font-family:Noto Sans SC;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:25px;
      text-align: center;
      margin: 14px auto auto auto;
    }
    .words6{
      width:252px;
      height:50px;
      font-size:18px;
      font-family:Noto Sans SC;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:25px;
      text-align: center;
      margin: 14px auto auto auto;
    }
    .home_ct_content_container_words2{
        font-size:18px;
        font-family:Noto Sans SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:25px;
        width:354px;
        height:77px;
        background: linear-gradient(180deg, #F9FBFF 0%, #E7EEFF 100%);
        box-shadow:0px 4px 9px 0px rgba(115,176,255,0.41);
        border-radius:4px;
        text-align: center;
        margin-left: -38px;
    }
    .home_ct_content_container_words3{
        font-size:18px;
        font-family:Noto Sans SC;
        font-weight:500;
        color:#ffffff;
        line-height:77px;
        width:354px;
        height:77px;
        background:rgba(164,193,255,1);
        box-shadow:0px 4px 9px 0px rgba(115,176,255,0.41);
        border-radius:4px;
        text-align: center;
    }
    .home_ct_content_container_words4{
        font-size:18px;
        font-family:Noto Sans SC;
        font-weight:500;
        color:#ffffff;
        line-height:77px;
        width:354px;
        height:77px;
        background:rgba(164,193,255,1);
        box-shadow:0px 4px 9px 0px rgba(115,176,255,0.41);
        border-radius:4px;
        text-align: center;
        margin-left: -40px;
    }
    .circle1{
        width:19px;
        height:18px;
        background:rgba(255,255,255,1);
        -moz-border-radius: 50%;      
        -webkit-border-radius: 50%;
        border:2px solid rgba(30,72,227,1);
        margin: 28px auto auto -10px;
    }
    .circle2{
        width:19px;
        height:18px;
        background:rgba(255,255,255,1);
        -moz-border-radius: 50%;      
        -webkit-border-radius: 50%;
        border:2px solid rgba(30,72,227,1);
        margin: 28px auto auto auto;
        z-index: 0;
    }
    .circle3{
        width:19px;
        height:18px;
        background:rgba(255,255,255,1);
        -moz-border-radius: 50%;      
        -webkit-border-radius: 50%;
        border:2px solid rgba(30,72,227,1);
        margin: 28px auto auto -10px;
    }
    
    

  .home_business_area{
    width:100%;
    background:rgba(249,251,253,1);
    overflow: hidden;
  }
  .home_business_content{
    width: 1200px;
    margin: auto;
    display: flex;
  }
  .home_business_left{
    font-size: 20px;
    line-height: 40px;
    width: 500px;
    margin-right: 60px;
    margin-bottom: 60px;
    color: #333333;
  }
  .home_business_left p{
    margin-bottom: 100px;
  }
  .home_business_left span{
    cursor: pointer;
    display: inline-block;
    width: 70px;
    height: 8px;
    margin-right: 20px;
    background: #5C1E7E;
  }
  .home_business_left_title{
    font-size: 36px;
    font-weight: 600;
    margin-bottom: 40px;
  }
  .home_business_right{
    width: 634px;

  }
    .home_product_program{
      background: #FFFFFF;
      width: 100%;
      height: 638px;
      overflow: hidden;
    }
    .home_pp_title{
      width:120px;
      height:42px;
      font-size:30px;
      font-family:Noto Sans SC;
      font-weight:500;
      color:rgba(51,51,51,1);
      line-height:42px;
      margin: 80px auto auto auto;
    }
    .home_pp_content{
      margin: 50px auto auto auto;
      width: 1320px;
      height: 380px;
      display: flex;
      justify-content: space-between;
    }
    .home_pp_content_middle{
      width: 1203px;
      height: 380px;
      overflow: hidden;
    }
    .home_pp_content_middle_inner{
      width: 1506px;
      height: 380px;
      display: flex;
      justify-content: space-between;
      margin-left: 0px;
      transition: all 0.5s;
    }
    .middle_inner-box{
      width: 286px;
      height:380px;
      background:rgba(255,255,255,1);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .home_pp_content_left{
      width:24px;
      height:49px;
      cursor: pointer;
      background:url('~@/../static/home_pp_content_left.png');
      margin: 165px auto auto 0px;
    }
    .home_pp_content_right{
      width:24px;
      height:49px;
      cursor: pointer;
      background:url('~@/../static/home_pp_content_right.png');
      margin: 165px 0px auto auto;
    }
    .middle_inner_png1{
      width:286px;
      height:267px;
      background:url('~@/../static/middle_inner_png1.png');
    }
    .middle_inner_png2{
      width:286px;
      height:267px;
      background:url('~@/../static/middle_inner_png2.png');
    }
    .middle_inner_png3{
      width:286px;
      height:267px;
      background:url('~@/../static/middle_inner_png3.png');
    }
    .middle_inner_png4{
      width:286px;
      height:267px;
      background:url('~@/../static/middle_inner_png4.png');
    }
    .middle_inner_png5{
      width:286px;
      height:267px;
      background:url('~@/../static/middle_inner_png5.png');
    }
    
    .ppwc{
      width: 286px;
      height: 113px;
      background: #f2f4f8;
      border-left:1px solid rgba(229,229,229,1);
      border-right:1px solid rgba(229,229,229,1);
      border-bottom:1px solid rgba(229,229,229,1);
    }
    .ppw{
      margin: 21px auto auto auto;
      font-size:20px;
      font-family:Noto Sans SC;
      font-weight:500;
      color:rgba(102,102,102,1);
      line-height:28px;
      text-align: center;
    }
    .b_w{
      margin: 8px auto auto 83px;
      width: 120px;
      height: 40px;
    }

    .home_news_center{
      width:100%;
      height:544px;
      background:rgba(242,244,248,1);
      overflow: hidden;
    }
    .home_nc_title{
      width:120px;
      height:42px;
      font-size:30px;
      font-family:Noto Sans SC;
      font-weight:500;
      color:rgba(51,51,51,1);
      line-height:42px;
      margin: 80px auto auto auto;
    }
    .home_nc_content{
      width: 1200px;
      height: 280px;
      display: flex;
      justify-content: space-between;
      margin: 48px auto 50px auto;
    }
    .home_nc_content_box{
      position: relative;
      width: 380px;
      height: 280px;
      cursor: pointer;
    }
    .more{
      position: absolute;
      font-size: 15px;
      right: 0;
      top: -40px;
      font-weight: 400;
      font-family: Noto Sans SC;
    }
    .resolve-content{
        margin: 0 auto;
        text-align: justify;
        text-indent:2em;
        width: 1200px;
        line-height: 30px;
        font-size: 20px;
    }
    .resolve-img{
        width: 100%;
        height: 423px;
        background: url('~@/../static/benefit-img.png') no-repeat center center;
        margin: 40px auto 80px auto;
    }
    .resolve{
        overflow: hidden;
        color: #333333;
        background: rgba(249,251,253,1);
    }
    .resolve-png{
        background: url('~@/../static/resolve-title.png');
    }
    .box_container{
      width:380px;
      height:190px;
      overflow: hidden;
    }
    .home_nc_news_png1{
      width:380px;
      height:190px;
      background:url('~@/../static/news200519_1.jpg');
      background-size: cover;
      transition: all 0.5s;
    }
    .home_nc_news_png1_scale{
      width:380px;
      height:190px;
      background:url('~@/../static/news200519_1.jpg');
      background-size: cover;
      transform:scale(1.1,1.1);
      transition: all 0.5s;
    }
    .home_nc_news_png2{
      width:380px;
      height:190px;
      background:url('~@/../static/news0004.jpg');
      background-size: cover;
      transition: all 0.5s;
    }
    .home_nc_news_png2_scale{
      width:380px;
      height:190px;
      background:url('~@/../static/news0004.jpg');
      background-size: cover;
      transform:scale(1.1,1.1);
      transition: all 0.5s;
    }
    .home_nc_news_png3{
      width:380px;
      height:190px;
      background:url('~@/../static/home_nc_news3.png');
      transition: all 0.5s;
    }
    .home_nc_news_png3_scale{
      width:380px;
      height:190px;
      background:url('~@/../static/home_nc_news3.png');
      transform:scale(1.1,1.1);
      transition: all 0.5s;
    }
    .home_nc_news_words{
      width: 380px;
      height: 90px;
      background:rgba(255,255,255,1);
      border:1px solid rgba(202,202,202,1);
      display: flex;
    }
    .home_nc_news_time{
      width: 80px;
      height: 100%;
      margin-left: 17px;
    }
    .home_nc_news_time_date{
      width:57px;
      height:28px;
      font-size:20px;
      font-family:Noto Sans SC;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:28px;
      margin: 22px auto auto 0;
      white-space: nowrap;
    }
    .home_nc_news_time_year{
      width:36px;
      height:21px;
      font-size:15px;
      font-family:Noto Sans SC;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:21px;
    }
    .home_nc_news_title{
      margin:14px auto auto 0px;
    }
    .home_nc_news_headline{
      width:258px;
      height:22px;
      font-size:16px;
      font-family:Noto Sans SC;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:22px;
      white-space: nowrap;
    }
    .home_nc_news_introduction{
      width:270px;
      height:34px;
      font-size:12px;
      font-family:Noto Sans SC;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:17px;
      margin: 5px auto auto 0px;
    }


    .home_cooperation{
      width: 100%;
      overflow: hidden;
    }
    .home_cooperation_content{
      width: 1200px;
      display: flex;
      flex-wrap: wrap;
      margin: 50px auto 50px auto;
    }
    .home_cooperation_content_box{
      width: 260px;
      height: 101px;
      overflow: hidden;
      margin-right: 40px;
      margin-bottom: 20px;
      overflow: hidden;
    }
    .home_cooperation_content_box .img_scale{
      transform:scale(1.2,1.1);
      transition: all 0.5s;
    }
    .home_cooperation_content_box .img_no_scale{
      transition: all 0.5s;
    }
</style>
<style>
  .ivu-carousel-dots-inside{
    margin-bottom: 20px!important;
  }
  .ivu-carousel-arrow{
      width: 70px!important;
      height: 70px!important;
  }
  .home_container .ivu-icon{
    transform:scale(2.5);
  }
</style>


// WEBPACK FOOTER //
// src/components/home.vue